import { rowsFragment } from './fragments.gql'

export default sku => `query {
  baseProduct(filter: {sku: {eq: "${sku}"}}) {
    url
    icon
    designImagesOrder
    useGenericReviews
    relatedProducts {
      products {
        sku
        icon
        url
      }
    }
    inTheBoxItems {
      id
      title
      description
      image {
        url
      }
    }
    quotes {
      image {
        url(imgixParams: {w: "250" h: "250", fit: clamp})
      }
      quote
    }
    heroFeatures {
      image {
        url(imgixParams: {w: "2000"})
        focalPoint {
          x
          y
        }
      }
      label
      title
      detailsLabel
      description
      lensTechFilter
    }
    techSpecs {
      id
      label
      icon
      value
      lensTechFilter
    }
    lensPreviewScenes {
      name: scene
      icon
    }
    lensPreviewConditions
    rowsAbove ${rowsFragment}
    rowsBelow ${rowsFragment}
  }
}`

export const pdpMappingQuery = `query {
  allBaseProducts {
    sku
    baseSku
    pageMode
    icon
  }
}`